import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const eventsStyles = makeStyles((theme: Theme) =>
    createStyles({
        content: {
            flexGrow: 1,
            marginTop: "120px",
            marginLeft: "50px",
        },
        gridItem: {
            minWidth: "150px",
            fontWeight: 500,
            fontSize: "14px",
        },
        titleContainer: { marginBottom: "50px" },
        title: {
            lineHeight: "41px",
            fontSize: "41px",
            fontWeight: 500,
            color: "#181818",
            marginBottom: "5px",
        },
        subTitle: {
            color: "#525252",
            width: "350px",
        },
        gridContainer: {
            marginTop: "30px",
            padding: "0px 40px 10px 20px",
        },

        pseudoIcon: { width: "90px" },
    })
);
